import React, { useEffect, useRef } from 'react';
import './PolygonSpinner.css';

export const PolygonSpinner = ({ onComplete }) => {
    const animationRef = useRef(null);

    useEffect(() => {
        // Имитация завершения загрузки
        if (onComplete) {
            animationRef.current = setTimeout(() => {
                onComplete();
            }, 3000);
        }

        return () => {
            if (animationRef.current) {
                clearTimeout(animationRef.current);
            }
        };
    }, [onComplete]);

    return (
        <div className="blob-spinner-container">
            <div className="spinner">
                <div className="blob top"></div>
                <div className="blob bottom"></div>
                <div className="blob left"></div>
                <div className="blob move-blob"></div>
            </div>
        </div>
    );
};